import defaultConfigs from "./options";
import axios from "@/libs/axios";
import Storage from "./core/storage";
import State from "./core/state";
import router from "@/router/index";
import store from "@/store";
import jwt_decode from "jwt-decode";
const jwt = require("jsonwebtoken");
// TODO: Complete state management in authentication flow
export default class AuthService {
  // Will be used by this service for making API calls
  axiosIns = null;

  // options <= Will be used by this service
  options = { ...defaultConfigs };

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false;

  // For Refreshing Token
  subscribers = [];

  $storage;

  constructor(defaults) {
    this.serviceDefinition = { ...defaults };

    this.axiosIns = axios;

    this.options = { ...this.options };

    this.$storage = new Storage();

    this.state = new State(store);

    this.$router = router;

    this.$jwtService = jwt;
  }

  loginWithOtp(...args) {
    try {
      return this.axiosIns
        .post(this.options.endpoints.loginWithOtp, ...args)
        .then((res) => {
          this.tokenManager(res.data).then(() => { });
          const decodedJwt = jwt_decode(res.data.accessToken);
          localStorage.setItem("storeId", decodedJwt.storeid);
          this.axiosIns.get("/Auth/GetUserInfo").then((data) => {
            localStorage.setItem("userInfo", JSON.stringify(data.data));
          });
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    } catch (_) { }
  }

  login(...args) {
    try {
      return this.axiosIns
        .post(this.options.endpoints.login, ...args)
        .then((res) => {
          this.tokenManager(res.data).then(() => { });
          const decodedJwt = jwt_decode(res.data.accessToken);
          localStorage.setItem("storeId", decodedJwt.storeid);
          this.axiosIns.get("/Auth/GetUserInfo").then((data) => {
            localStorage.setItem("userInfo", JSON.stringify(data.data));
          });
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    } catch (_) { }
  }

  getUserInfo(data) {
    try {
      this.tokenManager(data).then(() => { });
      return this.axiosIns
        .get("/Auth/GetUserInfo")
        .then((data) => {
          localStorage.setItem("userInfo", JSON.stringify(data.data));
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    } catch (_) { }
  }

  setReferralUser(...args) {
    try {
      return this.axiosIns
        .post(this.options.endpoints.referral.setReferralUser, ...args)
        .then((res) => { })
        .catch((err) => {
          return Promise.reject(err);
        });
    } catch (_) { }
  }

  getReferredUser({ pageIndex = 1, pageSize = 10 }) {
    let query = `pageIndex=${pageIndex}&pageSize=${pageSize}`;
    try {
      return this.axiosIns.get(
        this.options.endpoints.referral.getReferredUser + `?${query}`
      );
    } catch (_) { }
  }

  sendCode(args) {
    return this.axiosIns.post(this.options.endpoints.sendCode, args);
  }

  refreshToken() {
    return this.axiosIns.post(this.options.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    });
  }

  logout() {
    const data = {
      refreshToken: localStorage.getItem("refreshToken"),
    };
    return this.axiosIns
      .post(this.options.endpoints.logout, data)
      .then((res) => {
        this.$storage.clearLocalStorage();
        delete this.axiosIns.defaults.headers.common["Authorization"];
      })
      .catch((err) => {
        this.$storage.clearLocalStorage();
        delete this.axiosIns.defaults.headers.common["Authorization"];
        return Promise.reject(err);
      });
  }

  setUser(...userData) {
    this.$storage.setLocalStorage(this.options.storage.user, ...userData);
  }

  tokenManager(tokens) {
    const { accessToken, refreshToken } = tokens;
    if (!!accessToken) {
      this.$storage.setLocalStorage(this.options.storage.tokenKey, accessToken);
      this.axiosIns.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${accessToken}`;
    }
    if (!!refreshToken) {
      this.$storage.setLocalStorage(
        this.options.storage.refreshTokenKey,
        refreshToken
      );
    }
    return Promise.resolve();
  }

  isAuthenticated() {
    return !!this.getToken() ? true : false;
  }

  handleRouter(router) {
    router.beforeEach((to, from, next) => {
      if (this.isAuthenticated()) {
        if (to.name !== "login" || to.name !== "verify") {
          next();
        } else {
          next("/");
        }
      } else {
        if (to.name === "login" || to.name === "verify") {
          next();
        } else {
          if (to.query.password) {
            this.logout();
            next({ name: "login", query: { username: to.query.username, password: to.query.password } });
          }
          else {
            this.logout();
            next({ name: "login" });
          }
        }
      }
    });
  }

  getToken() {
    return this.$storage.getLocalStorage(this.options.storage.tokenKey) || null;
  }

  urlProvider(_url = "") {
    return _url
      .replace(
        "{version}",
        encodeURIComponent("" + this.serviceDefinition.version)
      )
      .replace(
        "{service}",
        encodeURIComponent("" + this.serviceDefinition.service)
      );
  }
}
